export default "__VITE_ASSET__BwW79zhh__"